module.exports = __webpack_public_path__ + "img/loading.695a4e66.gif";